import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { notifications } from "../notifications"
import { ActivateAccountState, isActivateAccountState, LoginState, LoggedInState } from "../state"
import { MinimalLoginWidgetData, update_state_with_route } from '../login';
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";

function handleSubmit<a, extra_user_info>(e: React.FormEvent<HTMLFormElement>, setState: (_: Action<LoginState<a, extra_user_info>>) => void) {
  e.preventDefault();
  setState(s =>
    isActivateAccountState(s)
      ? s.login_data.token !== undefined &&
        s.login_data.token !== "" &&
        s.login_data.email !== undefined &&
        s.login_data.email !== ""
          ? { status: "activate account - activating", login_data: s.login_data }
          : { ...s,
              login_data: {
                ...s.login_data,
                token: s.login_data.token === undefined ? "" : s.login_data.token,
                email: s.login_data.email === undefined ? "" : s.login_data.email }
            }
      : s
  );
}

export function activate_account_form<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ActivateAccountState, rootpath: string, readonly: boolean): Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key={options && options.key ? options.key : "login-widget-activate-account-form"}>
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "")}>
                <h1 className={getClassName(options, "title_classname", "mb-3")}>Activate account</h1>
                <p className={getClassName(options, "intro_classname", "")}>You are about to activate the account associated to this e-mail address:</p>
                <p className={getClassName(options, "intro_classname", "font-weight-bold mb-3")}>{s0.login_data.email}</p>
              </header>

              <form onSubmit={e => handleSubmit(e, setState)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}
      
                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-block btn-dark mb-4")}
                      disabled={readonly}
                    >
                      Activate account
                    </button>
                    
                    {data.without_browserRouter
                      ? <button
                          type="button"
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                          onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                        >
                          Sign in
                        </button>
                      : <Link to={rootpath} className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}>Sign in</Link>
                    }
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function activate_account_success<a, extra_user_info>(
  data:  MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) { 
  return (s0:LoggedInState<extra_user_info>, readonly:boolean) : Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-activate-account-success">
            <div className={getClassName(options, "inner_classname", "py-5")}>
              <header className={getClassName(options, "header_classname", "mb-3")}>
                <h1 className={getClassName(options, "title_classname", "mb-3")}>Activate account</h1>
                <p className={getClassName(options, "intro_classname", "lead")}>Your account has been activated and you can now login.</p>
              </header>

              <footer className={getClassName(options, "form_actions_classname", "")}>
                <button
                  className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                  disabled={readonly}
                  onClick={() => setState(s => ({
                    status: "logged out",
                    login_data: {
                      username: "",
                      password: "",
                      pin: { kind: "no pin" },
                      show_password: false
                    }
                  }))}
                >
                  Continue
                </button>
              </footer>
            </div>
          </section>
        )
      }
    })
  }
}
